import type { IBodyScrollLock } from './types';
import ZoomLocker from './ZoomLocker';

function getYPosition() {
  return (
    window.scrollY ||
    document.body.scrollTop ||
    document.documentElement.scrollTop
  );
}

const BodyScrollLock = (): IBodyScrollLock => {
  const stack: number[] = [];
  let index = 0;
  let hasScrollListener = false;
  const _scrollListener = () => {
    document.documentElement.style.setProperty(
      '--scroll-y',
      `${getYPosition()}px`
    );
  };

  const addScrollEvent = () => {
    if (hasScrollListener) {
      return;
    }
    window.addEventListener('scroll', _scrollListener);
    hasScrollListener = true;
  };

  if (typeof window !== 'undefined') {
    addScrollEvent();
  }

  const removeScrollEvent = () => {
    window.addEventListener('scroll', _scrollListener);
    hasScrollListener = false;
  };

  const unlock = () => {
    stack.pop();
    if (stack.length <= 0) {
      ZoomLocker.unlock();
      const { body } = document;
      const restoreScrollY = parseInt(body.style.top) * -1;
      body.style.top = '';
      body.style.position = '';
      body.style.width = '';
      body.style.height = '';
      document.documentElement.style.maxHeight = '';
      if (!isNaN(restoreScrollY)) {
        window.scrollTo(0, restoreScrollY);
      }
      removeScrollEvent();
    }
  };

  const cleanup = () => {
    stack.length = 0;
    removeScrollEvent();
    unlock();
  };

  const lock = () => {
    if (stack.length <= 0) {
      ZoomLocker.lock();

      const { body } = document;
      const scrollY =
        document.documentElement.style.getPropertyValue('--scroll-y') || 0;
      // negative scrollY
      body.style.width = '100%';
      body.style.height = '100%';
      body.style.top = `-${scrollY}`;
      body.style.position = 'fixed';
    }
    stack.push(index++);
  };
  return {
    cleanup,
    unlock,
    lock,
  };
};

export default BodyScrollLock();
